export enum COMMON_COMPONENT_TYPES {
  NavBar = "NavBar",
}

export enum COMPONENT_TYPES {
  NavBar = "NavBar",
  FirstFold = "FirstFold",
  VideoSlider = "BannerSlider",
  OnboardingSection = "OnboardingJourney",
  Discover = "SelCatList",
  CareTeam = "ApolloCareTeam",
  ToolsWidget = "ToolsWidget",
  QuickReads = "ArtBySelCatSlid",
  DoctorRecommendation = "DoctorRecommendation",
  Shop = "ShopByCatWid",
  TrendingReads = "TrendingReads",
  ExpertContent = "ExpertContent",
  WeeklyChanges = "WeeklyChanges",
  FAQ = "FaqListWithCat",
  FaqListWithTitle = "FaqListWithTitle",
  ArticlesByTag = "ArticlesByTag",
  DynamicClusters = "DynamicClusters",
  Banner = "AyurvedicCare",
  FAQWithTitle = "FaqListWithTitle",
  DynamicArticles = "DynamicArticles",
  BannerWithCard = "BannerWithCard",
  ClusterList = "ClusterList",
  VideoWidget1 = "VideoWidget1",
  ContentImageDesc = "ContentImageDesc",
  ClusterActionCards = "ClusterActionCards",
  ContentDescription = "ContentDescription",
  TopTips = "TopTips",
  ArticlesWithTagSlider = "ArticlesWithTagSlider",
  Index = "Index",
}

export const APPOINTMENT_URL = "https://www.apollo247.com/specialties/obstetrics-and-gynaecology?source=search_box";

export const HOME_PAGE_TITLE = "Home";
export const ONBOARDED_HOME_PAGE_TITLE = "For you";
export const FALLBAK_SEO_DATA = {
  title: "Mom Baby Web",
  description: "Apollo - Mom Baby Web",
};
